module.exports = __webpack_public_path__ + "img/45.d74b9297.jpg";